import api from "../http";

export default class PrimaryAPI {
    static async getAll() {
        return api.get('/primary/'); 
    }

    static async update(item) {
        return api.post('/primary/edit', item);
    }
}